export default () => ({
  activeMessageId: undefined,
  isHistoryShown: false,
});
